import { useQuery } from '@tanstack/react-query';
import { API } from '@/services/api.service';
import { QUERY_KEY } from '@/shared/constants';

export function useCompany(companyId) {
  return useQuery({
    queryKey: [QUERY_KEY.company, companyId],
    queryFn: async () => {
      if (!companyId) return null;
      return API.companies.getCompanyById(companyId);
    },
    enabled: !!companyId,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5, // Keep data fresh for 5 minutes
  });
}
